class Footer {
    constructor() {
        this.init();
    }

    init() {
        this.scrollToTop();
        this.RWDnavcolMenu();
    }

    scrollToTop() {
        const element = document.querySelector('[data-scroll-to-top]');
        if (!element) return false;

        element.addEventListener('click', e => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        });
    }

    RWDnavcolMenu() {
        $('.navcol__title').on('click', (e) => {
            let $_ = $(e.delegateTarget);
            if (window.matchMedia('(min-width:640px)').matches) return false;
            if ($_.hasClass('active')) {
                $_.removeClass('active');
                $_.siblings('.navcol-nav').stop(true, true).slideUp();
            } else {
                $_.addClass('active');
                $_.siblings('.navcol-nav').stop(true, true).slideDown();
            }

        })
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/assets/js/components/Footer.js